import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/scorito.webp';
import screenshot_target from '../../../images/letterfunnel/martijnvandijk.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Martijn van Dijk"
      firstname="Martijn"
      companyname="Scorito"
      competition="Voetbalpoules.nl en Poules.com"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/martijnvandijk.js